import uPlot from "uplot";

export function createChart(element, title) {
	let options = {
    title,
    cursor: {
      lock: false,
      drag: { x: true, y: true, uni: Infinity, dist: 3 },
    },
    legend: {
      show: true,
    },
    padding: [ 10, 0, 20, 10 ],
    scales: {
      x: {
        time: true,
        value: "{YYYY}-{MM}-{DD}",
        label: "Time",
        range(u, min, max) {
          return [min, max];
        },
      },
      y: {
        auto: false,
        range: [0, 250]
      },
    },
    series: [
      {
        value: (u, v) => v
      },
      {
        label: "Total",
        scale: "y",
        stroke: "gray",
        value: (u, v) => v?.toString() || 0,
      },
      {
        label: "Stock >= 50",
        scale: "y",
        stroke: "green",
        value: (u, v) => v?.toString() || 0,
      },
      {
        label: "Stock < 50",
        scale: "y",
        stroke: "red",
        value: (u, v) => v?.toString() || 0,
      }
    ],
    axes: [
      {
        space: 80,
        values: [
          // tick incr          default               year      month     day                               hour    min     sec       mode
          [3600 * 24 * 365,     "{YYYY}",             null,     null,     null,                             null,   null,   null,     1],
          [3600 * 24 * 20,      "{YYYY}-{MM}",        null,     null,     null,                             null,   null,   null,     1],
          [3600 * 24,           "{YYYY}-{MM}-{DD}",   null,     null,     null,                             null,   null,   null,     1],
          [3600,                "{HH}:{mm}",          null,     null,     "\n{YYYY}-{MM}-{DD}",             null,   null,   null,     1],
          [60,                  "{HH}:{mm}",          null,     null,     "\n{YYYY}-{MM}-{DD}",             null,   null,   null,     1],
          [1,                   "{HH}:{mm}:{ss}",     null,     null,     "\n{YYYY}-{MM}-{DD}",             null,   null,   null,     1],
          [0.001,               ":{ss}.{fff}",        null,     null,     "\n{YYYY}-{MM}-{DD} {HH}:{mm}",   null,   null,   null,     1],
        ],
      },
      {
        side: 1,
        scale: "y",
        label: "count",
        labelSize: 20,
        size: 50,
        stroke: "black",
        values: (u, vals) => vals,
        grid: { 
          show: true 
        },
        ticks: {
          stroke: "black",
          width: 1,
          size: 6
        }
      }
    ],
    hooks: {
      init: [
        uplot => {
          uplot.over.ondblclick = e => {
            const event = new CustomEvent("zoomOut");
            element.dispatchEvent(event);
          }
        }
      ],
      setSelect: [
        uplot => {
          let min = uplot.posToVal(uplot.select.left, "x");
          let max = uplot.posToVal(uplot.select.left + uplot.select.width, "x");
          const event = new CustomEvent("zoom", { detail: { min, max } });
          element.dispatchEvent(event);
        }
      ]
    }
  };
  return new uPlot(options, null, element);
}